<script setup>
import { IFrameHelper } from 'widget/helpers/utils';
import { CHATWOOT_ON_START_CONVERSATION } from '../constants/sdkEvents';
import AvailabilityContainer from 'widget/components/Availability/AvailabilityContainer.vue';

const props = defineProps({
  availableAgents: { type: Array, default: () => [] },
  hasConversation: { type: Boolean, default: false },
  showStartButton: { type: Boolean, default: true },
  previewStatus: { type: String, default: '' },
  previewReplyTime: { type: String, default: '' },
});

const emit = defineEmits(['startConversation']);

const startConversation = () => {
  emit('startConversation');
  if (!props.hasConversation) {
    IFrameHelper.sendMessage({
      event: 'onEvent',
      eventIdentifier: CHATWOOT_ON_START_CONVERSATION,
      data: { hasConversation: false },
    });
  }
};
</script>

<template>
  <div
    class="flex flex-col gap-3 w-full rounded-xl border border-solid border-slate-300/80 bg-n-background px-5 py-4 shadow-sm ring-1 ring-inset ring-white/80 dark:border-white/10 dark:bg-n-solid-2 dark:ring-white/10"
  >
    <div v-if="previewStatus" class="flex flex-col gap-1">
      <div class="font-medium text-n-slate-12">
        {{ previewStatus }}
      </div>
      <div class="text-n-slate-11">
        {{ previewReplyTime }}
      </div>
    </div>
    <AvailabilityContainer
      v-else
      :agents="availableAgents"
      show-header
      show-avatars
    />

    <button
      v-if="showStartButton"
      class="inline-flex items-center gap-1 font-medium text-[var(--widget-color)] outline-none focus-visible:ring-2 focus-visible:ring-[var(--widget-color)] focus-visible:ring-offset-2 focus-visible:ring-offset-n-background"
      @click="startConversation"
    >
      <span>
        {{
          hasConversation
            ? $t('CONTINUE_CONVERSATION')
            : $t('START_CONVERSATION')
        }}
      </span>
      <i class="i-lucide-chevron-right size-5 mt-px rtl:rotate-180" />
    </button>
  </div>
</template>
